import styled, { css } from 'styled-components';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';

// @TODO: (storm-v4) get border from tokens/theme/layer/card

const ContainerStyle = /*#__PURE__*/css(["color:", ";cursor:pointer;display:flex;font:", ";text-decoration:none;width:100%;box-sizing:border-box;:active,:link,:visited{color:", ";text-decoration:none;}:hover{color:", ";text-decoration:none;}:focus{outline:none;}:focus-visible{outline:none;", "}", ""], ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.text.color.default, focusOutline, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
const TouchLinkContainerStyle = /*#__PURE__*/css(["background:", ";border-radius:", ";border:", ";padding:", ";", ""], ({
  theme
}) => theme.surface.default, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["padding:", ";"], ({
  theme
}) => theme.spacing.xsmall.mobile)));
const TouchLinkAnchor = /*#__PURE__*/styled('a').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-0"
})(["", " ", ""], ContainerStyle, TouchLinkContainerStyle);
const TouchLinkButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-1"
})(["all:unset;", " ", ""], ContainerStyle, TouchLinkContainerStyle);
const InlineTouchLinkContainerStyle = /*#__PURE__*/css(["min-height:", ";"], ({
  theme
}) => theme.controls.height.base.mobile);
const InlineTouchLinkAnchor = /*#__PURE__*/styled('a').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-2"
})(["", " ", ""], ContainerStyle, InlineTouchLinkContainerStyle);
const InlineTouchLinkButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-3"
})(["all:unset;", " ", ""], ContainerStyle, InlineTouchLinkContainerStyle);
const TouchLinkContent = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-4"
})(["flex:1;display:flex;flex-direction:row;align-items:center;gap:", ";"], ({
  theme
}) => theme.spacing[250]);
const ChildrenContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-5"
})(["flex:1;"]);

// @TODO: (storm-v4) revise after Icon update
const TouchLinkIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1b2ofiz-6"
})(["color:", ";left:auto;inset-inline-start:auto;right:18px;inset-inline-end:18px;[dir=\"rtl\"] &&{right:auto;inset-inline-start:auto;left:18px;inset-inline-end:18px;}"], ({
  theme
}) => theme.text.color.default);

export { ChildrenContainer as C, InlineTouchLinkButton as I, TouchLinkButton as T, InlineTouchLinkAnchor as a, TouchLinkAnchor as b, TouchLinkContent as c, TouchLinkIcon as d };
//# sourceMappingURL=TouchLink.styles-DBynuPNk.js.map
